import type { FC } from "react";
import React from "react";

import HeaderRightButtonCircle from "../../../RightButtonCircle/HeaderRightButtonCircle";
import { createTestIdForCoreHeader } from "../../utils/createTestId";

import type { HeaderRightButtonProps, ICoreHeaderTextView } from "../../types";

const RIGHT_BUTTON_CIRCLE_SHEVRON_TEST_ID = createTestIdForCoreHeader(
    "right-button-circle-schevron",
);

type CoreHeaderSchevronRightButtonProps = Omit<
    HeaderRightButtonProps,
    "customVarsStyles" | "tabIndex" | "state"
> &
    ICoreHeaderTextView;

export const CoreHeaderRightButtonCircleSchevron: FC<
    CoreHeaderSchevronRightButtonProps
> = (props) => {
    const {
        "data-tsid": tsid = RIGHT_BUTTON_CIRCLE_SHEVRON_TEST_ID,
        view,
        type,
        "aria-label": ariaLabel,
    } = props;

    return (
        <HeaderRightButtonCircle
            view={view}
            type={type}
            aria-label={ariaLabel ?? " "}
            icon="glyph_right_16_20"
            data-tsid={tsid}
            tabIndex={-1}
            aria-hidden="true"
        />
    );
};

export default CoreHeaderRightButtonCircleSchevron;
